import { FEATURE_SHOW_MIAW_CHAT } from '../../../consts/env'
import { getPreviousChannelConfig } from '../utils/getPreviousChannelConfig'
import { logDevelopmentMessage } from '../utils/logDevelopmentMessage'
import { publishChatStartedEvent } from './publishChatStartedEvent'
import { dispatchOmnitureEvent } from './../utils/general'

const handleChatStartEvent = async (event: any) => {
  if (getPreviousChannelConfig()) return

  logDevelopmentMessage(`[MIAW] Start event received for ${JSON.stringify(event.detail)}`)

  try {
    window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields({
      Breadcrumb: FEATURE_SHOW_MIAW_CHAT ? event.detail.buttonLocation : event.detail.channel,
      ChatStartPageURL: window.location.href.slice(0, 255),
    })
    const utilAPI = window.embeddedservice_bootstrap?.utilAPI
    if (!utilAPI) {
      throw new Error('embeddedservice_bootstrap.utilAPI is not available')
    }

    await utilAPI.launchChat()
    dispatchOmnitureEvent('dataStateChange', {
      action: 'messaging',
      type: 'initiated',
    })
    publishChatStartedEvent()
  } catch (error) {
    console.error(`[MIAW] Failed launching chat`, error)
    window.dispatchEvent(new CustomEvent('jl-MIAW-conversations-chat-initialisation-failed'))
  }
}
  
export const subscribeToMIAWStartEvent = () => {
  window.removeEventListener('jl-MIAW-conversations-start-chat', handleChatStartEvent)
  window.addEventListener('jl-MIAW-conversations-start-chat', handleChatStartEvent)
}
